export default [
  {
    name: 'processMaintenanceList',
    path: '/process/maintenance/list',
    component: () => import('@/views/process/maintenance/list.vue'),
    meta: {
      title: '流程链路维护'
    }
  },
  {
    name: 'addProcessMaintenanceDetails',
    path: '/process/maintenance/add',
    component: () => import('@/views/process/maintenance/add.vue'),
    meta: {
      title: '新增链路维护',
      parentAuth: '/process/maintenance/list'
    },
    props: () => ({
      type: 'add'
    })
  },
  {
    name: 'editProcessMaintenanceDetails',
    path: '/process/maintenance/edit',
    component: () => import('@/views/process/maintenance/edit.vue'),
    meta: {
      title: '编辑链路维护',
      parentAuth: '/process/maintenance/list'
    },
    props: () => ({
      type: 'add'
    })
  },
]